// extracted by mini-css-extract-plugin
export var editButton = "_mg-0";